import React from 'react'

export type CycleIconProps = {
  width?: number
  height?: number
  strokeWidth?: number
  stroke?: string
}

const CycleIcon: React.FC<CycleIconProps> = ({
  width = 17,
  height = 16,
  strokeWidth = 2,
  stroke = '#550372'
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.83337 1.33325V5.49992H2.31797M15.1151 7.16659C14.705 3.87799 11.8997 1.33325 8.50004 1.33325C5.70223 1.33325 3.30695 3.05673 2.31797 5.49992M2.31797 5.49992H6.00004M15.1667 14.6666V10.4999H14.6821M14.6821 10.4999C13.6931 12.9431 11.2979 14.6666 8.50004 14.6666C5.10036 14.6666 2.29503 12.1218 1.88495 8.83325M14.6821 10.4999H11" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default CycleIcon
